

























































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'
import AgendaGarantiaMinimaStore from '../financeiro/Store/AgendaGarantiaMinimaStore'

@Component

export default class ComponentRemuneracaoAgendaGarantiaMinimaRightNavBar extends Vue {
  $refs: {
    menuDe: any,
    menuAte: any,
  }

  fltLoading: boolean = false
  menuDe: boolean = false
  menuAte: boolean = false

  get getPrestadoresList() {
    return this.getStore.prestadoresList
  }

  get getProfissionaisList() {
    return this.getStore.pessoaProfissionalExecutanteList
  }

  get getTurno() {
    return this.getStore.periodosList
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(AgendaGarantiaMinimaStore, this.$store)
  }

  get drawer() {
    return this.getStore.agendaGarantiaMinimaDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setAgendaGarantiaMinimaDrawer(value)
  }

  get getMenuDe() {
    return this.menuDe
  }

  set getMenuDe(value: boolean) {
    this.menuDe = value
  }

  get getMenuAte() {
    return this.menuAte
  }

  set getMenuAte(value: boolean) {
    this.menuAte = value
  }

  get dataDe() {
    return this.getStore.dataDe
  }

  set dataDe(value) {
    this.getStore.setDataDe(value)
  }

  get dataAte() {
    return this.getStore.dataAte
  }

  set dataAte(value) {
    this.getStore.setDataAte(value)
  }

  get selectedPrestador() {
    return this.getStore.selectedPrestador
  }

  set selectedPrestador(value) {
    this.getStore.setSelectedPrestador(value)
  }

  get selectedProfissional() {
    return this.getStore.selectedProfissional
  }

  set selectedProfissional(value) {
    this.getStore.setSelectedProfissional(value)
  }

  get selectedTurno() {
    return this.getStore.selectedTurno
  }

  set selectedTurno(value) {
    this.getStore.setSelectedTurno(value)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.getAllItemsAgendaGarantiaMinima()
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.selectedPrestador.length > 0 || this.getStore.selectedProfissional.length > 0 || this.getStore.dataDe !== null || this.getStore.dataAte !== null || this.getStore.selectedTurno.length > 0
  }

  async clear() {
    this.getStore.clearFiltroAvançado()
    this.getStore.setFilterOn(false)
    if (!this.hasAnyFilter()) {
      await this.search()
    }
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
